import { Box, Button, Typography } from '@mui/material'
import React from 'react'

interface Props {
  logoUrl?: string
  companyName: string
  onScoreNow: () => void
  onEdit: () => void
}

const StartupHeader = (props: Props) => {
  return (
    <Box 
      display='flex' 
      flexDirection='row' 
      justifyContent='space-between' 
      alignItems='center'
    >
      {props.logoUrl &&
        <img src={props.logoUrl} alt={props.companyName} style={{
          maxHeight: '56px'
        }} />
      }
      {!props.logoUrl &&
        <Typography variant='h1' sx={{
          padding: 2
        }}>{props.companyName}</Typography>
      }
      <Box display='flex' flexDirection='row' alignItems='center'>
        <Button onClick={props.onEdit} variant='outlined' color='primary' sx={{
          m: 1
        }}>
          Edit Startup
        </Button>
        <Button onClick={props.onScoreNow} variant='contained' color='primary' sx={{
          m: 1
        }}>
          Score Now
        </Button>
      </Box>
    </Box>
  )
}

export default StartupHeader
